import React from 'react'
import { Row, Typography } from 'antd'
import { CustomTitle, CustomCol } from 'src/components'
import styles from './OrderProjectDetailList.module.scss'
import { OrderProjectDetailLabel } from '../order-project.helpers'

interface OrderProjectDetailListProps {
  title: string
  labels: OrderProjectDetailLabel[]
}

const OrderProjectDetailList: React.FC<OrderProjectDetailListProps> = ({ title, labels }) => {

  return <>
    <CustomTitle label={title} type={null} />
    {labels.map((item, idx) => {
      if (!item.show) return
      return <Row key={idx}>
        <CustomCol xs={12}>
          <CustomTitle label={item.label} />
        </CustomCol>
        <CustomCol xs={12} className={styles.texts}>
          <Typography.Title level={5} type='secondary'>
            <strong>{item.strongLabel}</strong> &nbsp;
            {item.secondLabel && <span className={styles['second-label']}>{item.secondLabel}</span>}
          </Typography.Title>
        </CustomCol>
      </Row>
    })}
  </>
}

export default OrderProjectDetailList
